import { render } from "./banner1.vue?vue&type=template&id=3dbde011&scoped=true"
import script from "./banner1.vue?vue&type=script&lang=js"
export * from "./banner1.vue?vue&type=script&lang=js"

import "./banner1.vue?vue&type=style&index=0&id=3dbde011&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbde011"]])

export default __exports__